import { render, staticRenderFns } from "./designer.vue?vue&type=template&id=1b9a8f30"
import script from "./designer.vue?vue&type=script&lang=js"
export * from "./designer.vue?vue&type=script&lang=js"
import style0 from "./designer.vue?vue&type=style&index=0&id=1b9a8f30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports